export const itemBankExamStatsI18n = {
  itemBankExamStats: {
    tabTitle: 'Item statistics',
    intro: 'Results from submitted exam attempts. Pilot items are delivered but never count towards a learner\'s score. '
      + 'Figures appear once an item has {min} responses, and distractor checks once it has {minDistractors}.',
    loadError: 'Could not load item statistics',
    attemptsInView: '{count} submitted attempts in this view',
    filters: {
      quiz: 'Course and language',
      allQuizzes: 'All courses and languages',
      form: 'Form',
      allForms: 'All forms',
      from: 'Submitted from',
      to: 'Submitted to',
      role: 'Item type',
      allRoles: 'Pilot and scored',
      domain: 'Domain',
      allDomains: 'All domains',
      status: 'Item status',
      allStatuses: 'All statuses',
      flaggedOnly: 'Flagged for review only',
      search: 'Search item id, reference or text',
      target: 'Pilot response target',
      targetHint: 'Only used to show progress; not saved',
    },
    actions: {
      refresh: 'Refresh',
      exportResponses: 'Response matrix (CSV)',
      exportKey: 'Answer key (CSV)',
    },
    exportNotice: 'Exports identify learners by an anonymous id only, and use the course, form and date filters above. '
      + 'Each download is written to the audit log.',
    forms: {
      title: 'Forms',
      empty: 'No exam forms yet',
      emptyHint: 'Forms appear here once they are built on the Exams tab.',
      columns: {
        code: 'Form',
        language: 'Language',
        status: 'Status',
        attempts: 'Attempts',
        passRate: 'Pass rate',
        meanScore: 'Mean score',
        distribution: 'Score distribution',
      },
      statuses: {
        draft: 'Draft',
        active: 'Active',
        retired: 'Retired',
      },
      distributionNeeds: 'Needs {min} attempts',
      band: '{from}-{to}%: {count}',
    },
    items: {
      title: 'Items',
      empty: 'No items to show',
      emptyHint: 'Pilot and live items appear here once they have been delivered in an exam.',
      noMatch: 'No items match these filters',
      columns: {
        item: 'Item',
        type: 'Type',
        domain: 'Domain',
        status: 'Status',
        responses: 'Responses',
        pValue: '% correct',
        discrimination: 'Discrimination',
        options: 'Answer choices',
        time: 'Avg time',
        flags: 'Review',
      },
      roles: {
        pilot: 'Pilot',
        scored: 'Scored',
      },
      progress: '{count} of {target}',
      notEnough: 'Needs {min} responses',
      keyMarker: 'Correct answer',
      unanswered: 'Left unanswered: {share}',
      mixedVersions: 'Delivered as item versions {first} to {last}',
      seconds: '{value}s',
      ok: 'OK',
      open: 'Open item',
    },
    flags: {
      too_hard: 'Very hard: fewer than 30% answered correctly',
      too_easy: 'Very easy: more than 95% answered correctly',
      low_discrimination: 'Weak discrimination: below 0.15',
      weak_distractor: 'A wrong choice is picked by fewer than 5%',
    },
    flagShort: {
      too_hard: 'Hard',
      too_easy: 'Easy',
      low_discrimination: 'Discrimination',
      weak_distractor: 'Distractor',
    },
  },
};

export const itemBankExamStatsI18nEs = {
  itemBankExamStats: {
    tabTitle: 'Estadísticas de ítems',
    intro: 'Resultados de los intentos de examen enviados. Los ítems piloto se presentan pero nunca cuentan para la calificación. '
      + 'Las cifras aparecen con {min} respuestas, y las revisiones de distractores con {minDistractors}.',
    loadError: 'No se pudieron cargar las estadísticas de ítems',
    attemptsInView: '{count} intentos enviados en esta vista',
    filters: {
      quiz: 'Curso e idioma',
      allQuizzes: 'Todos los cursos e idiomas',
      form: 'Forma',
      allForms: 'Todas las formas',
      from: 'Enviado desde',
      to: 'Enviado hasta',
      role: 'Tipo de ítem',
      allRoles: 'Piloto y calificados',
      domain: 'Dominio',
      allDomains: 'Todos los dominios',
      status: 'Estado del ítem',
      allStatuses: 'Todos los estados',
      flaggedOnly: 'Solo ítems marcados para revisión',
      search: 'Buscar id, referencia o texto del ítem',
      target: 'Meta de respuestas piloto',
      targetHint: 'Solo se usa para mostrar el avance; no se guarda',
    },
    actions: {
      refresh: 'Actualizar',
      exportResponses: 'Matriz de respuestas (CSV)',
      exportKey: 'Clave de respuestas (CSV)',
    },
    exportNotice: 'Las exportaciones identifican a los estudiantes solo con un id anónimo y usan los filtros de curso, forma y fecha. '
      + 'Cada descarga se registra en el registro de auditoría.',
    forms: {
      title: 'Formas',
      empty: 'Todavía no hay formas de examen',
      emptyHint: 'Las formas aparecen aquí cuando se crean en la pestaña Exámenes.',
      columns: {
        code: 'Forma',
        language: 'Idioma',
        status: 'Estado',
        attempts: 'Intentos',
        passRate: 'Tasa de aprobación',
        meanScore: 'Puntaje medio',
        distribution: 'Distribución de puntajes',
      },
      statuses: {
        draft: 'Borrador',
        active: 'Activa',
        retired: 'Retirada',
      },
      distributionNeeds: 'Necesita {min} intentos',
      band: '{from}-{to}%: {count}',
    },
    items: {
      title: 'Ítems',
      empty: 'No hay ítems para mostrar',
      emptyHint: 'Los ítems piloto y vigentes aparecen aquí una vez que se presentan en un examen.',
      noMatch: 'Ningún ítem coincide con estos filtros',
      columns: {
        item: 'Ítem',
        type: 'Tipo',
        domain: 'Dominio',
        status: 'Estado',
        responses: 'Respuestas',
        pValue: '% correcto',
        discrimination: 'Discriminación',
        options: 'Opciones',
        time: 'Tiempo medio',
        flags: 'Revisión',
      },
      roles: {
        pilot: 'Piloto',
        scored: 'Calificado',
      },
      progress: '{count} de {target}',
      notEnough: 'Necesita {min} respuestas',
      keyMarker: 'Respuesta correcta',
      unanswered: 'Sin responder: {share}',
      mixedVersions: 'Presentado como versiones {first} a {last} del ítem',
      seconds: '{value} s',
      ok: 'OK',
      open: 'Abrir ítem',
    },
    flags: {
      too_hard: 'Muy difícil: menos del 30% respondió bien',
      too_easy: 'Muy fácil: más del 95% respondió bien',
      low_discrimination: 'Discriminación débil: menos de 0.15',
      weak_distractor: 'Una opción incorrecta la elige menos del 5%',
    },
    flagShort: {
      too_hard: 'Difícil',
      too_easy: 'Fácil',
      low_discrimination: 'Discriminación',
      weak_distractor: 'Distractor',
    },
  },
};
